'use strict';

exports.__esModule = true;
exports.Verbose = exports.DevNull = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _rws = require('./rws');

var _rws2 = _interopRequireDefault(_rws);

var _ron = require('@swarm/ron');

var _ron2 = _interopRequireDefault(_ron);

var _ronUuid = require('@swarm/ron-uuid');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// DevNull connection is used for permanent offline-mode
var DevNull = exports.DevNull = function () {
  function DevNull() {
    var _this = this;

    _classCallCheck(this, DevNull);

    this.readyState = 0;
    setTimeout(function () {
      _this.readyState = 0;
      _this.onopen && _this.onopen(new Event(''));
    }, 0);
  }

  DevNull.prototype.send = function send(data) {
    var _this2 = this;

    if (!this.onmessage) return;
    var frame = new _ron.Frame(data);
    if (!frame.isPayload()) return;

    var _loop = function _loop(op) {
      if (!op.uuid(2).eq(_ronUuid.ZERO)) {
        setTimeout(function () {
          // $FlowFixMe
          _this2.onmessage({ data: '@' + op.uuid(2).toString() + '!' });
        }, 0);
        return {
          v: void 0
        };
      }
    };

    for (var _iterator = frame, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref = _i.value;
      }

      var op = _ref;

      var _ret = _loop(op);

      if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
    }
  };

  DevNull.prototype.close = function close() {};

  DevNull.prototype.open = function open() {};

  return DevNull;
}();

var Verbose = exports.Verbose = function (_RWS) {
  _inherits(Verbose, _RWS);

  function Verbose(url) {
    var protocols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Verbose);

    var _this3 = _possibleConstructorReturn(this, _RWS.call(this, url, protocols, options));

    var send = _this3.send;
    _this3.send = function (data) {
      console.log('%c(≶) %c%s %c%s', 'color: blue', 'color: green;', '~>', 'color: #aaa', data);
      send(data);
    };
    return _this3;
  }

  _createClass(Verbose, [{
    key: 'onopen',
    get: function get() {
      var _this4 = this;

      return function (ev) {
        console.log('%c(≶) %c%s', 'color: blue;', 'color: green;',
        // $FlowFixMe
        'connected to ' + _this4._url);
        _this4._oo(ev);
      };
    },
    set: function set(m) {
      this._oo = m;
    }
  }, {
    key: 'onmessage',
    get: function get() {
      var _this5 = this;

      return function (ev) {
        console.log('%c(≶) %c%s %c%s', 'color: blue;', 'color: red;', '<~', 'color: #aaa', ev.data);
        _this5._om(ev);
      };
    },
    set: function set(m) {
      this._om = m;
    }
  }]);

  return Verbose;
}(_rws2.default);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@swarm/client/lib/connection.js
// module id = 31
// module chunks = 0